import { defineComponent as _defineComponent } from 'vue';
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, Transition as _Transition, withCtx as _withCtx, createBlock as _createBlock } from "vue";
var _hoisted_1 = {
    key: 0,
    class: "line__item"
};
var _hoisted_2 = { class: "text text--sm text--placeholder" };
import { computed, onMounted, ref, watch } from "vue";
import { useDeliveryApi } from "../../../../api/deliveryApi";
import EventBus from "../../../../events/EventBus";
export default /*@__PURE__*/ _defineComponent({
    __name: 'DeliveryMethodsNotice',
    props: {
        address: {
            type: Object,
            required: true,
        },
    },
    setup: function (__props) {
        var props = __props;
        watch(function () { return props.address; }, updateList);
        var names = {
            pickpoint: 'PickPoint',
            fivepost: '5Post',
            post: 'Почтой России',
            courier: 'Курьером',
            cdek: 'СДЭК',
        };
        var currentCity = ref();
        var deliveryList = ref();
        var visibleDeliveryList = computed(function () {
            var result = [];
            if (deliveryList.value) {
                for (var key in deliveryList.value) {
                    if (key === props.address.delivery.name || !deliveryList.value[key].available) {
                        continue;
                    }
                    result.push(names[key]);
                }
            }
            return result;
        });
        var loading = ref(false);
        function updateList() {
            if (loading.value || currentCity.value === props.address.cityFias && deliveryList.value || (!props.address.cityFias || !props.address.region)) {
                return;
            }
            loading.value = true;
            deliveryList.value = {};
            useDeliveryApi().getDeliveryInfo(props.address.region, props.address.cityFias, props.address.zipCode, false, props.address.beltway)
                .then(function (result) {
                loading.value = false;
                deliveryList.value = result.services;
                currentCity.value = props.address.cityFias;
                EventBus.emit('order:delivery-list-updated', result.services);
            });
        }
        onMounted(updateList);
        return function (_ctx, _cache) {
            return (_openBlock(), _createBlock(_Transition, { name: "line__item" }, {
                default: _withCtx(function () { return [
                    (visibleDeliveryList.value.length)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                            _createElementVNode("div", _hoisted_2, [
                                _cache[0] || (_cache[0] = _createTextVNode("\n        Другие способы доставки: ", -1 /* CACHED */)),
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(visibleDeliveryList.value, function (item) {
                                    return (_openBlock(), _createElementBlock("strong", { key: item }, _toDisplayString(item), 1 /* TEXT */));
                                }), 128 /* KEYED_FRAGMENT */))
                            ])
                        ]))
                        : _createCommentVNode("v-if", true)
                ]; }),
                _: 1 /* STABLE */
            }));
        };
    }
});
